import React from "react";

const Mission = () => {
  return (
    <div className="bg-gray-100 min-h-screen py-12 px-6 sm:px-8 lg:px-10">
      <div className="max-w-5xl mx-auto bg-white shadow-lg rounded-lg overflow-hidden">
        {/* Header Section */}
        <header className="bg-gradient-to-r from-blue-500 to-teal-400 p-6 text-white text-center">
          <h1 className="text-4xl font-extrabold mb-2">Mission</h1>
          <p className="text-lg font-light">
            BuildPro: Elevating Construction Procurement & Expertise
          </p>
        </header>

        <div className="p-8">
          {/* Section: BuildPro Platform */}
          <section className="mb-8">
            <h2 className="text-2xl font-semibold text-gray-800 border-b-2 border-blue-500 mb-4 pb-2">
              BuildPro: The Future of Construction Procurement
            </h2>

            <p className="text-gray-700 text-lg leading-relaxed">
              BuildPro is a comprehensive procurement platform designed to simplify transactions for both suppliers and construction organizations. It enhances efficiency, transparency, and decision-making in construction projects.
            </p>

            {/* Benefits for Agencies/Suppliers */}
            <h3 className="text-xl font-medium text-gray-800 mt-6 mb-3">For Agencies/Suppliers:</h3>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li><strong>Increased Visibility:</strong> Showcase your materials and equipment to a broad audience of construction organizations, increasing your reach and potential customer base.</li>
              <li><strong>Streamlined Transactions:</strong> Simplify the procurement process by providing detailed product specifications, prices, and delivery times in one place.</li>
              <li><strong>Efficient Comparisons:</strong> Benefit from easy comparisons with other suppliers, enhancing competitive positioning.</li>
              <li><strong>Enhanced Communication:</strong> Improve interactions with buyers through clear, comprehensive product information and quick response times.</li>
              <li><strong>Data Insights:</strong> Access valuable insights on buyer preferences and market trends to better tailor your offerings and strategies.</li>
            </ul>

            {/* Benefits for Construction Organizations/Buyers */}
            <h3 className="text-xl font-medium text-gray-800 mt-6 mb-3">For Construction Organizations/Buyers:</h3>
            <ul className="list-disc list-inside text-gray-700 space-y-2">
              <li><strong>Comprehensive Access:</strong> Connect with a diverse range of suppliers and manufacturers for all your building material and equipment needs.</li>
              <li><strong>One-Click Comparisons:</strong> Quickly obtain and compare detailed product specifications, quality standards, prices, and delivery times for informed decision-making.</li>
              <li><strong>Efficiency and Convenience:</strong> Save time by accessing all necessary procurement information in one place, avoiding the need for multiple visits or extensive research.</li>
              <li><strong>Quality Assurance:</strong> Review product specifications and quality standards to ensure that materials meet project requirements.</li>
              <li><strong>Timely Delivery:</strong> Compare delivery times to choose suppliers that fit your project schedule, minimizing delays.</li>
            </ul>
          </section>

         
         
        </div>
      </div>
    </div>
  );
};

export default Mission;
